<template>
  <!--加载失败-->
  <div v-if="errorMessage" class="error-message">
    错误：{{ errorMessage }}
  </div>
  <!--业务类型选择器-->
  <div v-else>
    <van-cell-group title="申请信息">
      <van-field
        v-model="applicationInfo.businessTypeAlias"
        label="业务类型"
        size="large"
        readonly
        label-width="90px"
      />
      <template v-if="isEditable">
        <van-field
          v-model="applicationInfo.registrationItemAlias"
          v-validate="{required:true}"
          data-vv-as="登记事项"
          label="登记事项"
          size="large"
          placeholder="选择登记事项"
          readonly
          required
          clickable
          label-width="90px"
          @click="showRegistrationItemPicker = true"
        />
        <van-popup v-model="showRegistrationItemPicker" position="bottom">
          <van-picker
            :columns="registrationItems"
            show-toolbar
            :loading="!isLoaded"
            value-key="alias"
            :default-index="registrationItemPickerDefaultIndex"
            @confirm="handleRegistrationItemPickerConfirm"
            @cancel="showRegistrationItemPicker = false"
          />
        </van-popup>
      </template>
      <van-field
        v-else
        :value="applicationInfo.registrationItemAlias"
        label="登记事项"
        size="large"
        readonly
        label-width="90px"
      />
      <template v-if="isEditable">
        <van-field
          v-model="applicationInfo.bDCQZH"
          v-validate="{required:true}"
          data-vv-as="产权证号"
          label="产权证号"
          size="large"
          placeholder="选择产权证号"
          readonly
          required
          clickable
          label-width="90px"
          @click="showCqzhPicker = true"
        />
        <van-popup v-model="showCqzhPicker" position="bottom">
          <van-picker
            :columns="landAndHouseProperties"
            show-toolbar
            :loading="!isLoaded"
            value-key="bDCQZH"
            :default-index="landAndHousePropertyPickerDefaultIndex"
            @confirm="handleCqzhPickerConfirm"
            @cancel="showCqzhPicker = false"
          />
        </van-popup>
      </template>
      <van-field
        v-else
        :value="applicationInfo.bDCQZH"
        label="产权证号"
        size="large"
        readonly
        label-width="90px"
      />
      <div v-if="showSQZT">
        <template v-if="isEditable">
          <van-field
            v-model="applicationInfo.sQZT"
            v-validate="{required:true}"
            data-vv-as="申请主体"
            label="申请主体"
            size="large"
            placeholder="选择申请主体"
            required
            :readonly="!isEditable"
            clickable
            label-width="90px"
            @click="handleSqztClick"
          />
          <van-popup v-model="showSqztPicker" position="bottom" :readonly="!isEditable">
            <van-picker
              :columns="sqztPickerValueList"
              show-toolbar
              :default-index="sQZTPickerDefaultIndex"
              @confirm="handleSqztPickerConfirm"
              @cancel="showSqztPicker = false"
            />
          </van-popup>
        </template>
        <van-field
          v-else
          :value="applicationInfo.sQZT"
          label="申请主体"
          size="large"
          readonly
          label-width="90px"
        />
      </div>

      <van-field
        v-model="applicationInfo.remark"
        label="备注"
        type="textarea"
        size="large"
        :maxlength="500"
        placeholder="填写其他需要备注的信息"
        :readonly="!isEditable"
        label-width="90px"
        :rows="4"
        autosize
      />
    </van-cell-group>
    <van-cell-group v-if="applicationInfo.qlrList.length>0" :title="obligeeLabel+'信息'">
      <div v-for="(obligee,index) in applicationInfo.qlrList" :key="index">
        <van-cell :title="obligeeLabel+(index+1).toString()">
          <template v-if="showObligeeAddButton" slot>
            <!--这里要加逻辑通过index判断显示哪个按钮-->
            <van-button
              v-show="index==0"
              size="mini"
              type="primary"
              @click="addObligee('qlrList')"
            >
              添加
            </van-button>
            <van-button v-show="index>0" size="mini" type="danger" @click="deleteObligee(index)">
              删除
            </van-button>
          </template>
        </van-cell>
        <obligee-form
          :obligee="obligee"
          :data-vv-scope="'obligee'+index"
          :is-editable="obligeeIsEditable"
          @validate="handleObligeeValidate($event,index)"
        />
      </div>
    </van-cell-group>
    <van-cell-group v-if="applicationInfo.ywrList.length>0" :title="obligorLabel+'信息'">
      <div v-for="(obligor,index) in applicationInfo.ywrList" :key="index">
        <van-cell :title="obligorLabel+(index+1).toString()">
          <template v-if="showObligorAddButton" slot>
            <!--这里要加逻辑通过index判断显示哪个按钮-->
            <van-button
              v-show="index==0"
              size="mini"
              type="primary"
              @click="addObligee('ywrList')"
            >
              添加
            </van-button>
            <van-button v-show="index>0" size="mini" type="danger" @click="deleteObligee(index)">
              删除
            </van-button>
          </template>
        </van-cell>
        <obligee-form
          :obligee="obligor"
          :data-vv-scope="'obligor'+index"
          :is-editable="obligorIsEditable"
          @validate="handleObligorValidate($event,index)"
        />
      </div>
    </van-cell-group>

    <van-cell-group v-if="changeInfo.showChangeInfo" title="变更信息">
      <ChangeForm
        :application-info="applicationInfo"
        :change-info="changeInfo"
        :data-vv-scope="'applicationInfo'"
        :show-hose-z-l="changeInfo.showHoseZL"
        @validate="handleBHNRValidate($event)"
      />
    </van-cell-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import to from 'await-to-js'
import ObligeeForm from './ObligeeForm'
import ChangeForm from './ChangeForm'
import {
  checkHouseStatus
} from '@/api/application'
import { Toast, Dialog } from 'vant'
export default {
  components: {
    ObligeeForm,
    ChangeForm
  },
  props: {
    // 在 JavaScript 中对象和数组是通过引用传入的，
    // 所以对于一个数组或对象类型的 prop 来说，
    // 在子组件中改变这个对象或数组本身将会影响到父组件的状态。
    applicationInfo: {
      type: Object,
      default: () => {
        return {
          businessTypeId: '',
          businessTypeName: '',
          businessTypeAlias: '',
          businessTypeCode: '',
          aTBusinessTypeCode: '',
          registrationItemId: '',
          registrationItemName: '',
          registrationItemAlias: '',
          registrationItemCode: '',
          applicantName: '',
          applicantIdNumber: '',
          applicantMobilePhone: '',
          remark: '',
          jJQLRs: [],
          qlrList: [], // 权利人列表
          ywrList: [], // 义务人列表
          bDCQZH: '', // 产权证号
          bDCDYH: '', // 不动产单元号
          sQZT: '', // 申请主体
          bHNR: '' // 变化内容
        }
      }
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    action: {
      // 动作(判断是发起还是修改)
      type: String,
      default: 'Start'
    },
    handleSubmit: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    return {
      isLoaded: false,
      errorMessage: '',
      showRegistrationItemPicker: false,
      registrationItemPickerDefaultIndex: 0,
      landAndHousePropertyPickerDefaultIndex: 0,
      sQZTPickerDefaultIndex: 0,
      showCqzhPicker: false, // 显示产权证号Picker
      sqztPickerValueList: ['个人对个人', '个人对企业'], // 申请主体Picker控件值列表
      showSqztPicker: false, // 显示申请主体Picker
      obligeeLabel: '权利人',
      obligorLabel: '义务人',
      obligeeIsEditable: true, // 权利人是否可编辑
      obligorIsEditable: true, // 义务人是否可编辑
      showObligeeAddButton: false, // 显示权利人添加按钮
      showObligorAddButton: false, // 显示义务人添加按钮
      showSQZT: false, // 显示申请主体
      changeInfo: {// 变更信息详情（用于处理变更业务）
        needVaild: false, // 需要验证
        _isValid: false, // 是否验证通过
        showChangeInfo: false, // 显示变更信息
        showHoseZL: false, // 显示变更信息--房屋坐落
        showHoseMj: false, // 显示变更信息--房屋面积
        showHoseYt: false, // 显示变更信息--房屋用途
        showHoseXz: false, // 显示变更信息--房屋性质
        currentHouseZl: '', // 当前房屋坐落
        currentHouseMj: '', // 当前房屋面积
        currentHouseYt: '', // 当前房屋用途
        currentHouseXz: '' // 当前房屋性质
      }
    }
  },
  computed: {
    ...mapGetters(['webUserInfo', 'businessTypes', 'houseBusinesses']),
    availableHouseBusinesses() {
      return this.houseBusinesses.filter(
        b => (b.mortgages == null || b.mortgages.length === 0)
      )
    },
    landAndHouseProperties() {
      return this.availableHouseBusinesses.map(b => b.landAndHouseProperty)
    },
    registrationItems() {
      const businessType = this.businessTypes.find(
        businessType => businessType.id === this.applicationInfo.businessTypeId
      )
      return businessType
        ? businessType.registrationItems.filter(r => {
          return r.isEnabled === true
        })
        : []
    },
    validationErrors() {
      return this.$validator.errors
    },
    registrationItem() {
      return this.registrationItems.find(
        r => r.id === this.applicationInfo.registrationItemId
      )
    },
    landAndHouseProperty() {
      return this.landAndHouseProperties.find(
        h => h.bDCDYH === this.applicationInfo.bDCDYH
      )
    }
  },
  watch: {
    validationErrors: {
      handler(newValue, oldValue) {
        this.validate()
      },
      deep: true
    },
    // qlrList  ywrList 改成data并监听 重要
    'applicationInfo.qlrList': {
      handler(newValue, oldValue) {
        this.applicationInfo.jJQLRs = this.applicationInfo.jJQLRs.filter(j => {
          return j.qLRDIRECT === 1 // 找义务人
        })
        // 然后把权利人加进去
        this.applicationInfo.jJQLRs = this.applicationInfo.jJQLRs.concat(
          newValue
        )
      },
      deep: true
    },
    'applicationInfo.ywrList': {
      handler(newValue, oldValue) {
        this.applicationInfo.jJQLRs = this.applicationInfo.jJQLRs.filter(j => {
          return j.qLRDIRECT === 0 // 找权利人
        })
        // 然后把义务人加进去
        this.applicationInfo.jJQLRs = this.applicationInfo.jJQLRs.concat(
          newValue
        )
      },
      deep: true
    }
  },
  created() {
    // 加载数据
    this.loadData()
  },
  mounted() {
    // 验证表单
    this.$validator.validateAll()
  },
  methods: {
    // 验证表单
    validate() {
      const isValid =
        !this.validationErrors.any() && // 当前表单无验证错误
        !this.applicationInfo.qlrList.some(qlr => !qlr._isValid) && // 所有权利人表单无验证错误
        !this.applicationInfo.ywrList.some(ywr => !ywr._isValid) && // 所有义务人表单无验证错误
        !(this.changeInfo.needVaild && this.changeInfo._isValid === false) // 变化内容表单无验证错误
      this.$emit('validate', isValid)
    },
    // 加载数据
    async loadData() {
      if (this.isEditable) {
        // 获取业务类型
        if (this.businessTypes.length === 0) {
          const [error] = await to(
            this.$store.dispatch('application/getBusinessTypes')
          )
          if (error) {
            // 设置错误信息
            this.errorMessage = error.message
          }
        }
        // 获取房屋业务
        if (this.houseBusinesses.length === 0) {
          const [error] = await to(
            this.$store.dispatch('application/getHouseBusinesses')
          )
          if (error) {
            // 设置错误信息
            this.errorMessage = error.message
          }
        }
        // todo:判断只读模式
        // 选择默认登记事项
        if (this.applicationInfo.registrationItemId) {
          this.selectDefaultRegistrationItem()
        }
        // this.handeleRegistrationItemPickerDefautSelected()
        this.selectDefautLandAndHouseProperty()
        this.selectDefautSQZT()
      }
      // 第一次加载完数据，执行初始化表单的方法
      this.initApplicationInfo()
      // 设置加载状态为已加载
      this.isLoaded = true
    },
    // 选择默认登记事项
    selectDefaultRegistrationItem() {
      const defaultSelectedRegistrationItem = this.registrationItems.find(
        registrationItem =>
          registrationItem.id === this.applicationInfo.registrationItemId
      )
      if (defaultSelectedRegistrationItem) {
        // 设置登记事项选择器默认选中项索引
        this.registrationItemPickerDefaultIndex = this.registrationItems.findIndex(
          registrationItem =>
            registrationItem.id === this.applicationInfo.registrationItemId
        )
      }
    },
    // 处理产权证号默认选中
    selectDefautLandAndHouseProperty() {
      if (
        this.landAndHouseProperties.length > 0 &&
        this.landAndHouseProperties
          .map(l => l.bDCDYH)
          .indexOf(this.applicationInfo.bDCDYH) !== -1
      ) {
        this.landAndHousePropertyPickerDefaultIndex = this.landAndHouseProperties.findIndex(
          l => l.bDCDYH === this.applicationInfo.bDCDYH
        )
      }
      // 申请主体
    },
    // 处理申请主体默认选中
    selectDefautSQZT() {
      if (
        this.sqztPickerValueList.length > 0 &&
        this.sqztPickerValueList.indexOf(this.applicationInfo.sQZT) !== -1
      ) {
        this.sQZTPickerDefaultIndex = this.sqztPickerValueList.findIndex(
          s => s === this.applicationInfo.sQZT
        )
      }
      // 申请主体
    },
    // 处理登记事项选择器确定
    handleRegistrationItemPickerConfirm(registrationItem) {
      this.applicationInfo.registrationItemId = registrationItem.id
      this.applicationInfo.registrationItemName = registrationItem.name
      this.applicationInfo.registrationItemAlias = registrationItem.alias
      this.applicationInfo.registrationItemCode = registrationItem.code
      this.showRegistrationItemPicker = false
      // 执行初始化表单方法
      this.initApplicationInfo()
    },
    // 初始化申请信息
    initApplicationInfo() {
      const busCode = this.applicationInfo.businessTypeCode
      const regCode = this.applicationInfo.registrationItemCode
      if (!busCode || !regCode) {
        return
      }
      if (this.action === 'Start') {
        // 如果不是编辑
        this.initQlrAndYwrList()
      }
      // 判断业务类型编码
      if (busCode === 'fw-zy-zy') {
        // 转移登记
        this.showSQZT = true
        this.obligorIsEditable = false
        this.showObligeeAddButton = true
        // 判断登记事项编码
        if (regCode === 'fw-zy-zy-mm') {
          // 买卖
          this.obligeeLabel = '受让人'
          this.obligorLabel = '转让人'
        } else if (regCode === 'fw-zy-zy-jc') {
          // 继承
          this.obligeeLabel = '继承人'
          this.obligorLabel = '被继承人'
        } else if (regCode === 'fw-zy-zy-zy') {
          // 赠与
          this.obligeeLabel = '受赠人'
          this.obligorLabel = '赠与人'
        } else if (regCode === 'fw-zy-zy-syz') {
          // 受遗赠
          this.obligeeLabel = '受遗赠人'
          this.obligorLabel = '遗赠人'
        }
      } else if (busCode === 'fw-bg-fw') {
        // 变更登记
        this.initChangeInfo()
        this.obligeeLabel = '申请人'
        this.obligeeIsEditable = false
      } else if (busCode === 'fw-qt-bh') { // 房产证补、换不动产权证
        this.obligeeLabel = '权利人'
        this.obligeeIsEditable = false
        if (regCode === 'fw-qt-bh-ysbf') {
          // 遗失补发
        }
      }
    },
    // 初始化权利人和义务人列表
    initQlrAndYwrList() {
      if (!this.applicationInfo.bDCDYH) {
        return
      }
      const busCode = this.applicationInfo.businessTypeCode
      if (busCode === 'fw-zy-zy') { // 转移登记
      // 设置转让人列表
        this.applicationInfo.ywrList = []
        this.landAndHouseProperty.ownerships.forEach(({ obligee }) => {
          this.applicationInfo.ywrList.push({
            qLRMC: obligee.qLRMC, // 权利人名称
            zJLB: obligee.zJLB, // 证件类型
            zJLBNAME: obligee.zJLBNAME, // 证件类别名称
            zJHM: obligee.zJHM, // 证件号码
            dH: this.webUserInfo.mobilePhone, // 电话
            gJ: '142', // 国家
            gJNAME: '中国', // 国家名称
            qLRLX: '1', // 权利人类型
            qLRLXNAME: '个人', // 权利人类型名称
            f_SITE_ID: 0, // 默认为0
            iNPUT_INDEX: 0, // 默认为0
            qLRDIRECT: 1 // 转让方(义务人)
          })
        })
        let qLRLX = '1'
        let qLRLXNAME = '个人'
        if (
          this.applicationInfo.sQZT != null &&
          this.applicationInfo.sQZT === '个人对企业'
        ) {
          qLRLX = '2'
          qLRLXNAME = '企业'
        }
        // 设置受让人列表
        this.applicationInfo.qlrList = [
          {
            qLRMC: null, // 权利人名称
            zJLB: null, // 证件类型
            zJLBNAME: null, // 证件类别名称
            zJHM: null, // 证件号码
            dH: null, // 电话
            gJ: '142', // 国家
            gJNAME: '中国', // 国家名称
            qLRLX: qLRLX, // 权利人类型
            qLRLXNAME: qLRLXNAME, // 权利人类型名称
            f_SITE_ID: 0, // 默认为0
            iNPUT_INDEX: 0, // 默认为0
            qLRDIRECT: 0 // 受让方(权利人)
          }
        ]
      } else if (busCode === 'fw-bg-fw') {
        // 设置权利人列表
        this.applicationInfo.qlrList = []
        this.landAndHouseProperty.ownerships.forEach(({ obligee }) => {
          this.applicationInfo.qlrList.push({
            qLRMC: obligee.qLRMC, // 权利人名称
            zJLB: obligee.zJLB, // 证件类型
            zJLBNAME: obligee.zJLBNAME, // 证件类别名称
            zJHM: obligee.zJHM, // 证件号码
            dH: this.webUserInfo.mobilePhone, // 电话
            gJ: '142', // 国家
            gJNAME: '中国', // 国家名称
            qLRLX: '1', // 权利人类型
            qLRLXNAME: '个人', // 权利人类型名称
            f_SITE_ID: 0, // 默认为0
            iNPUT_INDEX: 0, // 默认为0
            qLRDIRECT: 0 // 权利人
          })
        })
      } else if (busCode === 'fw-qt-bh') { // 房产证补、换不动产权证
        // 设置权利人列表
        this.applicationInfo.qlrList = []
        this.landAndHouseProperty.ownerships.forEach(({ obligee }) => {
          this.applicationInfo.qlrList.push({
            qLRMC: obligee.qLRMC, // 权利人名称
            zJLB: obligee.zJLB, // 证件类型
            zJLBNAME: obligee.zJLBNAME, // 证件类别名称
            zJHM: obligee.zJHM, // 证件号码
            dH: this.webUserInfo.mobilePhone, // 电话
            gJ: '142', // 国家
            gJNAME: '中国', // 国家名称
            qLRLX: '1', // 权利人类型
            qLRLXNAME: '个人', // 权利人类型名称
            f_SITE_ID: 0, // 默认为0
            iNPUT_INDEX: 0, // 默认为0
            qLRDIRECT: 0 // 权利人
          })
        })
      }
    },
    // 初始化变更信息
    initChangeInfo() {
      this.changeInfo = this.$options.data().changeInfo // 重置changeInfo中的数据
      if (this.landAndHouseProperty == null) return
      this.changeInfo.showChangeInfo = true
      if (this.applicationInfo.registrationItemCode === 'fw-bg-fw-zl') {
        // 房屋坐落
        this.changeInfo.showHoseZL = true // 显示房屋坐落
        // 设置原房屋地址
        this.changeInfo.currentHouseZl = this.landAndHouseProperty.fDZL
      } else if (this.applicationInfo.registrationItemCode === 'fw-bg-fw-mj') {
        // 房屋面积
        this.changeInfo.showHoseMj = true // 显示房屋面积
        // 设置原房屋面积
        this.changeInfo.currentHouseMj = this.landAndHouseProperty.jZMJ
      } else if (this.applicationInfo.registrationItemCode === 'fw-bg-fw-yt') {
        // 房屋用途
        this.changeInfo.showHoseYt = true // 显示房屋用途
        // 设置原房屋面积
        if (!this.landAndHouseProperty.houseInfo) {
          return
        }
        let currentHouseYt = this.landAndHouseProperty.houseInfo.fWYT1NAME
        if (this.landAndHouseProperty.houseInfo.fWYT2NAME) {
          currentHouseYt = currentHouseYt + this.landAndHouseProperty.houseInfo.fWYT2NAME
        } else if (this.landAndHouseProperty.houseInfo.fWYT3NAME) {
          currentHouseYt = currentHouseYt + this.landAndHouseProperty.houseInfo.fWYT3NAME
        }
        this.changeInfo.currentHouseYt = currentHouseYt
      } else if (this.applicationInfo.registrationItemCode === 'fw-bg-fw-xz') {
        // 房屋性质
        this.changeInfo.showHoseXz = true
        this.changeInfo.currentHouseXz = this.landAndHouseProperty.fWXZNAME
      }
    },
    // 处理权利人表单验证
    handleObligeeValidate(isValid, index) {
      if (this.applicationInfo.qlrList[index]._isValid !== isValid) {
        this.applicationInfo.qlrList[index]._isValid = isValid
        this.validate()
      }
    },
    // 处理义务人表单验证
    handleObligorValidate(isValid, index) {
      if (this.applicationInfo.ywrList[index]._isValid !== isValid) {
        this.applicationInfo.ywrList[index]._isValid = isValid
        this.validate()
      }
    },
    // 处理更正表单验证
    handleBHNRValidate(isValid) {
      if (isValid != null) {
        this.changeInfo._isValid = isValid
      }
      this.validate()
    },
    // 处理产权证号选择器确定
    handleCqzhPickerConfirm(landAndHouseProperty) {
      const property = landAndHouseProperty
      this.applicationInfo.bDCDYH = property.bDCDYH
      this.applicationInfo.bDCQZH = property.bDCQZH
      this.showCqzhPicker = false
      // 执行初始化表单方法
      this.initApplicationInfo()
    },
    // 处理申请主体输入框点击
    handleSqztClick() {
      this.showSqztPicker = true
    },
    // 处理申请主体选择器确定
    handleSqztPickerConfirm(sqztData) {
      this.showSqztPicker = false
      this.applicationInfo.sQZT = sqztData
      // 如果选择的是个人对个人
      const code =
        this.registrationItem == null ? '' : this.registrationItem.code
      if (sqztData === '个人对个人') {
        switch (code) {
          case 'fw-zy-zy-mm': // 买卖
            this.applicationInfo.qlrList.forEach(q => {
              q.qLRLX = '1'
              q.qLRLXNAME = '个人'
            })
        }
      } else if (sqztData === '个人对企业') {
        switch (code) {
          case 'fw-zy-zy-mm': // 买卖
            this.applicationInfo.qlrList.forEach(q => {
              q.qLRLX = '2'
              q.qLRLXNAME = '企业'
            })
        }
      }
      this.applicationInfo.ywrList.forEach(q => {
        q.qLRLX = '1'
        q.qLRLXNAME = '个人'
      })
    },
    // 添加权利人
    addObligee(propName) {
      if (propName === 'qlrList') {
        let qLRLX = '1'
        let qLRLXNAME = '个人'
        if (this.applicationInfo.sQZT === '个人对企业') {
          qLRLX = '2'
          qLRLXNAME = '企业'
        }
        this.applicationInfo.qlrList.push({
          qLRMC: '', // 权利人名称
          zJLB: '', // 证件类型
          zJLBNAME: '', // 证件类别名称
          zJHM: '', // 证件号码
          dH: '', // 电话
          gJ: '142', // 国家
          gJNAME: '中国', // 国家名称
          qLRLX: qLRLX, // 权利人类型
          qLRLXNAME: qLRLXNAME, // 权利人类型名称
          f_SITE_ID: 0, // 默认为0
          iNPUT_INDEX: 0, // 默认为0
          qLRDIRECT: 0 // 受让方(权利人)
        })
      } else {
        this.obligeeList.push({
          qLRMC: '', // 权利人名称
          zJLB: '', // 证件类别
          zJLBNAME: '', // 证件类别名称
          zJHM: '', // 证件号码
          dH: '', // 电话
          gJ: '142', // 国家
          gJNAME: '中国', // 国家名称
          qLRLX: '1', // 权利人类型
          qLRLXNAME: '个人', // 权利人类型名称
          f_SITE_ID: 0, // 默认为0
          iNPUT_INDEX: 0, // 默认为0
          qLRDIRECT: 1 // 转让方
        })
      }
    },
    deleteObligee(index) {
      this.applicationInfo.qlrList.splice(index, 1)
    },
    resetApplicationInfo() {
      this.applicationInfo.jJQLRs = []
      this.applicationInfo.qlrList = []
      this.applicationInfo.ywrList = []
      this.applicationInfo.bDCDYH = ''
      this.applicationInfo.bDCQZH = ''
      this.applicationInfo.sQZT = ''
      this.applicationInfo.bHNR = ''
      this.showSQZT = false
      this.obligeeIsEditable = true
      this.obligorIsEditable = true
      this.showObligeeAddButton = false
      this.showObligorAddButton = false
      this.changeInfo = this.$options.data().changeInfo
    },
    // 验证房屋状态
    getCheckHouseStatus() {
      const ywlx = this.applicationInfo.aTBusinessTypeCode
      const bdcdyh = this.applicationInfo.bDCDYH
      checkHouseStatus({ ywlx: ywlx, bdcdyh: bdcdyh })
        .then(({ data }) => {
          if (data.type === 1) {
            Dialog.confirm({
              title: '提示',
              message: '当前房屋：' + data.message
            }).then(() => {
              this.handleSubmit()
            }).catch(() => {
            })
          } else if (data.type === 2) {
            Toast.fail('当前房屋：' + data.message)
            return
          } else {
            this.handleSubmit()
          }
        })
        .catch(error => {
          // 设置列表加载失败
          Toast.fail(error.message)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.error-message {
  color: #ee0a24;
  margin-top: 15px;
  text-align: center;
}
</style>
